export const ACCOUNT_MANAGEMENT_FEATURE_NAME = 'accountManagement';
